module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAAKBAMAAAB/HNKOAAAAJ1BMVEUTdb0VdbsJdcdHcEwAd9MAdtE6c583cps9dZ6hcDXVbwHBcBXAbxb5P5iVAAAACXRSTlP1sfIAIic1ODI9tMFeAAAANElEQVQI12MwDlQSMWYw59w9IZkhYNWqVSwMkkByIoM2kDwEJSEiDmBZM84zE5oZjB2BugCBKBWRcfmehgAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/indicator-dot.png
// module id = 2792
// module chunks = 1